import { axiosWithAuth } from "../../helpers";

export const scheduleAService = {
	getScheduleA,
	addScheduleA,
	editScheduleA,
	getCompanyScheduleA,
	getScheduleAHistory,
};

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

function getScheduleA({ userId, scheduleId }) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/agents/${userId}/residuals/schedules/a/${scheduleId}`,
	};

	return axiosWithAuth(options);
}

function addScheduleA({ userId, data }) {
	const options = {
		method: "POST",
		data,
		url: `${API_URL}/api/agents/${userId}/residuals/schedules/a`,
	};

	return axiosWithAuth(options);
}

function editScheduleA({ userId, scheduleId, data }) {
	const options = {
		method: "PUT",
		data,
		url: `${API_URL}/api/agents/${userId}/residuals/schedules/a/${scheduleId}`,
	};

	return axiosWithAuth(options);
}

function getCompanyScheduleA({ companyId, scheduleId }) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/companies/${companyId}/residuals/schedules/a/${scheduleId}`,
	};

	return axiosWithAuth(options);
}

function getScheduleAHistory({ page, id }) {
	const options = {
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			applicationId: id,
		},
		url: `${API_URL}/api/modifications/schedule_as/${id}`,
	};

	return axiosWithAuth(options);
}
